import React from "react";
import { getSubjectTagStyle, getTagDisplayLabel } from "../../utils/myNotes";

function NoteSubjectTag({ tag, className = "" }) {
  if (!tag) {
    return null;
  }

  return (
    <span
      className={`my-notes-subject-tag ${className}`.trim()}
      style={getSubjectTagStyle(tag)}
      title={tag}
    >
      {getTagDisplayLabel(tag)}
    </span>
  );
}

export default NoteSubjectTag;
